import axios from '../utils/axios';
let userApi={
    // 登录
    dologin(params, success){
        axios('/manageuser/dologin', params, success)
    },
    // 获取用户列表
    getmanageuserlist(params, success){
        axios('/manageuser/getmanageuserlist', params, success)
    },
    // 新增用户
    adduser(params, success){
        axios('/manageuser/adduser', params, success)
    },
    // 删除用户
    deleteuser(params, success){
        axios('/manageuser/deleteuser', params, success)
    },
    // 重置密码
    resetpassword(params, success){
        axios('/manageuser/resetpassword', params, success)
    },
    // 修改用户信息
    updateuser(params, success){
        axios('/manageuser/updateuser', params, success)
    },
    // 修改用户密码
    updatepword(params, success){
        axios('/manageuser/updatepword', params, success)
    },

}
export default userApi


// WEBPACK FOOTER //
// ./src/api/user.js